import './App.css';
import {useEffect, useRef} from "react";

let intId;
function App() {
  const dot = useRef(null);

  useEffect(() => {
    if (intId) clearInterval(intId);

    if (dot.current) {
      intId = setInterval(() => {
        if (dot.current.innerText === '...') dot.current.innerText = '';
        dot.current.innerText += '.';
      }, 500)
    }
  }, [dot])
  return (
    <div className="App">
      <header className="App-header">
        <h1>Welcome To My Blog 🎉</h1>
        <small>Coming Soon<span ref={dot}></span></small>
        {process.env.NODE_ENV}
      </header>
    </div>
  );
}

export default App;
